import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import dayjs from "dayjs";

const AddEventModal = ({
  open,
  onClose,
  onSave,
  eventData,
  setEventData,
  users = [],
}) => {
  const modalCardSx = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "92%", sm: 520 },
    maxHeight: "90vh",
    overflowY: "auto",
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(10px)",
    borderRadius: "18px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    overflow: "hidden",
    outline: "none",
  };

  const fieldSx = {
    mt: 1.25,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255,255,255,0.96)",
      borderRadius: "10px",
    },
  };

  const primaryButtonSx = {
    backgroundColor: "#2f63ad",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 2.25,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1f4f94",
      boxShadow: "none",
    },
  };

  const secondaryButtonSx = {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 600,
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="add-event-modal">
      <Box sx={modalCardSx}>
        <Box
          sx={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: "1.35rem",
            pt: 3,
            pb: 1,
            color: "#1f1f1f",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Add New Event
          </Typography>
        </Box>

        <Box sx={{ px: 3, pb: 1 }}>
          <Typography
            sx={{
              mt: 0.5,
              mb: 1,
              textAlign: "center",
              color: "#666",
              fontSize: "0.95rem",
            }}
          >
            Enter the event details below to create a new calendar event.
          </Typography>

          <TextField
            label="Event Title"
            fullWidth
            value={eventData.title || ""}
            onChange={(e) =>
              setEventData((prev) => ({ ...prev, title: e.target.value }))
            }
            sx={fieldSx}
          />

          <TextField
            label="Start Time"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={
              eventData.start
                ? dayjs(eventData.start).format("YYYY-MM-DDTHH:mm")
                : ""
            }
            onChange={(e) =>
              setEventData((prev) => ({
                ...prev,
                start: e.target.value ? new Date(e.target.value) : null,
              }))
            }
            sx={fieldSx}
          />

          <TextField
            label="End Time"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={
              eventData.end
                ? dayjs(eventData.end).format("YYYY-MM-DDTHH:mm")
                : ""
            }
            onChange={(e) =>
              setEventData((prev) => ({
                ...prev,
                end: e.target.value ? new Date(e.target.value) : null,
              }))
            }
            sx={fieldSx}
          />

          <FormControl fullWidth sx={fieldSx}>
            <InputLabel id="assign-label">Assign To</InputLabel>
            <Select
              labelId="assign-label"
              label="Assign To"
              value={eventData.assigned_to_user_id || ""}
              onChange={(e) =>
                setEventData((prev) => ({
                  ...prev,
                  assigned_to_user_id: e.target.value,
                }))
              }
            >
              {users.map((user) => (
                <MenuItem key={user.UserID} value={user.UserID}>
                  {user.Name} {user.Lastname}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Description"
            fullWidth
            multiline
            rows={3}
            value={eventData.description || ""}
            onChange={(e) =>
              setEventData((prev) => ({
                ...prev,
                description: e.target.value,
              }))
            }
            sx={fieldSx}
          />
        </Box>

        <Box
          sx={{
            px: 3,
            pb: 3,
            pt: 1.5,
            display: "flex",
            justifyContent: "center",
            gap: 1.25,
          }}
        >
          <Button onClick={onClose} variant="outlined" sx={secondaryButtonSx}>
            Cancel
          </Button>

          <Button onClick={onSave} variant="contained" sx={primaryButtonSx}>
            Save Event
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddEventModal;